module.exports = {
  api: {
    API_URL: "https://api-node.themesbrand.website",
    // API_URL: "https://api-cosmos.sebs.asia/api/v1",
  }
};
